// ModeToggle.tsx
import React from "react";
import { Mode } from "../../hooks/useHoldingsHistory";

export default function ModeToggle({
                                       mode,
                                       setMode,
                                       onResetErrors,
                                   }: {
    mode: Mode;
    setMode: (m: Mode) => void;
    onResetErrors: () => void;
}) {
    const wrap: React.CSSProperties = {
        display: "inline-flex",
        background: "#141414",
        borderRadius: 12,
        // stroke without using 'border'
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.06)",
        overflow: "hidden",
    };

    const btnBase: React.CSSProperties = {
        padding: "10px 14px",
        background: "transparent",
        color: "#fff",
        cursor: "pointer",
        fontWeight: 700,
        fontSize: 13,
        outline: "none",
        border: "none", // important: NO border shorthands
        lineHeight: 1,
    };

    const activeShadow = "inset 0 0 0 1px rgba(255,255,255,0.12)";
    const inactiveShadow = "inset 0 0 0 1px rgba(255,255,255,0.00)";
    const dividerShadow = "inset -1px 0 0 rgba(255,255,255,0.06)";

    return (
        <div role="tablist" aria-label="Mode" style={wrap}>
            <button
                role="tab"
                aria-selected={mode === "institution"}
                onClick={() => { setMode("institution"); onResetErrors(); }}
                style={{
                    ...btnBase,
                    background: mode === "institution" ? "#2b2b2b" : "transparent",
                    // compose shadows without borders
                    boxShadow: `${mode === "institution" ? activeShadow : inactiveShadow}, ${dividerShadow}`,
                }}
            >
                By Institution
            </button>
            <button
                role="tab"
                aria-selected={mode === "ticker"}
                onClick={() => { setMode("ticker"); onResetErrors(); }}
                style={{
                    ...btnBase,
                    background: mode === "ticker" ? "#2b2b2b" : "transparent",
                    boxShadow: mode === "ticker" ? activeShadow : inactiveShadow,
                }}
            >
                By Ticker
            </button>
        </div>
    );
}
